import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, off, child } from "firebase/database";

export const fetchChatMessages = (bookingId) => (dispatch) => {

    const {
        chatRef
    } = firebase;
  
    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });
    onValue(chatRef(bookingId), snapshot => {
        if(snapshot.val()){
            let rootEntry = snapshot.val();
            let allMesseges = [];
            for (let key in rootEntry) {
                let entryKey = rootEntry[key]
                for (let msgKey in entryKey) {
                  entryKey[msgKey].smsId = msgKey
                  allMesseges.push(entryKey[msgKey])
                }
            }
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: allMesseges,
            });
        }else{
            dispatch({
                type: FETCH_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    })
};

// Construye un preview corto para el push notification según el kind del mensaje.
function previewForPush(kind, msg) {
    switch (kind) {
        case 'image':    return '📷 Foto';
        case 'video':    return '🎬 Video';
        case 'audio':    return '🎤 Audio' + (msg?.durationMs ? ` (${Math.round(msg.durationMs / 1000)}s)` : '');
        case 'location': return '📍 Ubicación';
        case 'file':     return '📎 ' + (msg?.fileName || msg?.path?.split('/').pop() || 'Archivo');
        default:         return msg?.text || '';
    }
}

export const sendMessage = (data) => (dispatch) => {

    const {
        chatRef
    } = firebase;

    const chatId = data.booking.customer + ','  + data.booking.driver
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;

    // Backwards compat: si llega `data.message` string sin kind, tratamos como text.
    // Si llega `data.payload`, es un mensaje multimedia ya armado por el cliente.
    const payload = data.payload && typeof data.payload === 'object' ? data.payload : null;
    const kind = payload?.kind || 'text';

    const baseMsg = {
        from: data.role == 'customer' ? data.booking.customer : data.booking.driver,
        type: 'msg',
        msgDate: today,
        msgTime: time,
        createdAt: new Date().toString(),
        source: data.role,
        kind,
    };

    let msg;
    if (kind === 'text') {
        msg = { ...baseMsg, message: data.message, text: data.message };
    } else if (kind === 'image' || kind === 'video' || kind === 'audio' || kind === 'file') {
        msg = {
            ...baseMsg,
            message: previewForPush(kind, payload), // para retrocompatibilidad de la lista
            url: payload.url,
            path: payload.path,
            contentType: payload.contentType || null,
            size: payload.size || 0,
            durationMs: payload.durationMs || null,
            width: payload.width || null,
            height: payload.height || null,
            fileName: payload.fileName || null,
            caption: payload.caption || null,
        };
    } else if (kind === 'location') {
        msg = {
            ...baseMsg,
            message: previewForPush('location', payload),
            coords: payload.coords || null,            // { lat, lng }
            address: payload.address || null,          // string opcional
            label: payload.label || null,
        };
    } else {
        // Tipo desconocido — guardamos lo que vino
        msg = { ...baseMsg, ...payload };
    }

    push(child(chatRef(data.booking.id), chatId), msg);

    const pushPreview = previewForPush(kind, msg);
    const pushTitle = store.getState().languagedata.defaultLanguage.notification_title
        + store.getState().languagedata.defaultLanguage.chat_requested;

    if(data.role == 'customer'){
        if(data.booking.driver_token){
            RequestPushMsg(
                data.booking.driver_token,
                {
                    title: pushTitle,
                    msg: pushPreview,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id }
                });
        }
    }else{
        if(data.booking.customer_token){
            RequestPushMsg(
                data.booking.customer_token,
                {
                    title: pushTitle,
                    msg: pushPreview,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id}
                });
        }
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
}

export const stopFetchMessages = (bookingId) => (dispatch) => {

    const {
        chatRef 
    } = firebase;

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
}